//**********/ common functions to modify drill down data *********

export function modifyDataDrill(data) {
  if (!data) return;

  var drillDown = [];
  // console.log(data,"DRILL DOWN DATA")
  for (let i = 0; i < data.length; i++) {
    var obj = {};
    obj["Country"] = data[i]["fund_asset_class_focus"];
    obj["Model"] = data[i]["fund_name"];
    obj["Total"] = data[i]["allocation"] * 1;
    drillDown.push(obj);
  }
  return drillDown;
}

export function drillDownModify(data) {
  if (!data) return;

  let b = [];
  b = data.map((key) => key["fund_asset_class_focus"]);
  let c = {};
  b.map((e) => {
    c[e] = e;
  });

  let color = [
    "#303b91",
    "#36c6d3",
    "#66b3ff",
    "#C1D3D7",
    "#507786",
    "#9A9CAA",
    "#AAAAFF",
    "#FFB5C5",
    "#E35152",
    "#9AFF9A",
    "#5A6351",
    "#8B864E",
  ];
  let clrObj1 = {};
  let count = 0;
  for (let i in data) {
    if (!clrObj1[data[i]["fund_asset_class_focus"]]) {
      clrObj1[data[i]["fund_asset_class_focus"]] = color[count];
      count++;
    }
  }
  var chartOption = [
    {
      captions: [{ ...c }],
      color: [{ ...clrObj1 }],
      xaxis: "Country",
      xaxisl1: "Model",
      yaxis: "Total",
    },
  ];
  return chartOption;
}



// WEBPACK FOOTER //
// ./src/components/pages/compare/commonFunctions.js